export default {"src":"/_next/static/media/drainage.daf561f8.svg","height":116,"width":97,"blurWidth":0,"blurHeight":0};